import React, { useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateEncodeSpecificationMpeg1Form } from "../forms/create/CreateEncodeSpecificationMpeg1Form";

export type AddEncodeSpecificationMpeg1ButtonProps = ButtonProps;

export const AddEncodeSpecificationMpeg1Button: React.FC<AddEncodeSpecificationMpeg1ButtonProps> = (
    props: AddEncodeSpecificationMpeg1ButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add MPEG-1" icon="Add" disabled={disabled} />
            <Aside
                isOpen={isAsideOpen}
                type="form"
                headerText={"Add Encode Specification MPEG-1"}
                onDismiss={closeAside}
            >
                <CreateEncodeSpecificationMpeg1Form onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
